import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuthStore, selectUser } from "@safers/auth";
import { useCurrentSiteId } from "@/hooks/useCurrentSiteId";
import { writeLastArea, writeLastSite } from "@/lib/lastVisit";
import { areaOf } from "@/routes/paths";

/**
 * 지금 보고 있는 영역·현장을 적어 둔다. 다음 로그인이 이 자리로 착지한다.
 *
 * 쓰기는 이펙트에서 — 렌더 중에 외부 스토리지를 건드리지 않는다.
 */
export function useRememberVisit(): void {
  const { pathname } = useLocation();
  const siteId = useCurrentSiteId();
  const username = useAuthStore(selectUser)?.username ?? null;
  const area = areaOf(pathname);

  useEffect(() => {
    if (!username || !area) return;
    writeLastArea(username, area);
  }, [username, area]);

  useEffect(() => {
    if (!username || siteId == null) return;
    writeLastSite(username, String(siteId));
  }, [username, siteId]);
}
